import { useSearchParams, Link } from "react-router-dom";
import { Logo, WordMark } from "@/components/Logo";
import { CheckCircle2, XCircle } from "lucide-react";

export default function PracticeConfirmed() {
  const [params] = useSearchParams();
  const code = params.get("code");
  const status = params.get("status");
  const isInvalid = status === "invalid";

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-md mx-auto px-5 h-14 flex items-center">
          <Logo className="h-14" />
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-5">
        <div className="card-gs max-w-md w-full text-center !pt-10 !pb-10">
          {isInvalid ? (
            <>
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center">
                <XCircle className="w-10 h-10 text-red-600" />
              </div>
              <h1 className="text-2xl font-black text-[#1E293B] mb-2">Link non valido</h1>
              <p className="text-slate-600 mb-6">Il link di conferma è scaduto o già usato.</p>
            </>
          ) : (
            <>
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-100 flex items-center justify-center">
                <CheckCircle2 className="w-10 h-10 text-green-600" />
              </div>
              <h1 className="text-2xl font-black text-[#1E293B] mb-2">Pratica firmata!</h1>
              <p className="text-slate-600 mb-4">
                La pratica <b data-testid="confirmed-code">{code}</b> è stata firmata elettronicamente.
              </p>
              <p className="text-xs text-slate-500 mb-6">
                Firma elettronica semplice (FES) ai sensi del Reg. UE 910/2014.
              </p>
            </>
          )}
          <Link to="/" data-testid="confirmed-home-link" className="btn-gs-primary inline-flex">Torna alla home</Link>
        </div>
      </main>
      <footer className="text-center py-6">
        <WordMark className="text-sm" />
        <div className="text-[10px] text-slate-400 mt-1">Marchio di TotalKlick srls</div>
      </footer>
    </div>
  );
}
